// extracted by mini-css-extract-plugin
export default {"container":"Qca-z","heading":"Rca-z","links":"Sca-z","linkBtn":"Tca-z","disabled":"Uca-z","linkUppercaseBold":"Vca-z","copy":"Wca-z","subCopy":"Xca-z"};